import React from 'react'
import { formatedDate } from '../../Helper/constent';

const StockTransferPrint = ({ purchaseDetails = {}, products = [], user = {}, isShow = false }) => {

    const groupedProducts = products.reduce((acc, product) => {
        if (!acc[product.category_name]) {
            acc[product.category_name] = [];
        }
        acc[product.category_name].push(product);
        return acc;
    }, {});

    return (
        <div className={`puechase-invoice-container ${!isShow && 'd-none'}`}>
            <div className={`puechaseee-invoice-container`}>
                <center className="d-flex justify-content-center align-items-center">
                    <img src={purchaseDetails.store_logo_url} alt="Logo" width={120} />
                </center>
                <p className='text-center my-2'>{purchaseDetails.store_address}</p>
                <div className="puechase-invoice-header">
                    <p>From : {purchaseDetails.from_store_address}</p>
                    <p>To : {purchaseDetails.to_store_address}</p>
                </div>
                <div className="puechase-invoice-details">
                    <p><strong>Invoice Number:</strong> <br /> {purchaseDetails.invoice_number}</p>
                    <p><strong>Date:</strong> <br /> {formatedDate(purchaseDetails?.inv_transfer_date)}</p>
                </div>
                <div className="puechase-invoice-details">
                    <p><strong>Print by:</strong> {user.user_name}</p>
                    <p><strong>Status:</strong> {Number(purchaseDetails.purchase_status) === 0 ? "Pending" : "Verified"}</p>
                </div>

                {/* Product List by Category */}
                <div className="puechase-product-list">
                    <table>
                        <thead>
                            <tr>
                                <th className='text-start'>Items</th>
                                <th className='text-end'>Qty</th>
                                <th className='text-end'>Price</th>
                                <th className='text-end'>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(groupedProducts).map(([category, items]) => (
                                <React.Fragment key={category}>
                                    {/* Category Row */}
                                    <tr className="puechase-category-row">
                                        <td colSpan="4" className="puechase-category-header">
                                            <strong>{category}</strong>
                                        </td>
                                    </tr>
                                    {/* Product Rows */}
                                    {items.map((product, index) => (
                                        <tr key={index}>
                                            <td className='text-start'>{product.product_name}</td>
                                            <td className='text-end'>{product.stock_qty}</td>
                                            <td className='text-end'>{product.stock_purchase_price}</td>
                                            <td className='text-end'>{product.total_amount}</td>
                                        </tr>
                                    ))}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="puechase-invoice-footer">
                    <p><strong>GRAND TOTAL :</strong> Rs {purchaseDetails.grand_total_amount} /-</p>
                </div>
            </div>
        </div>
    )
}

export default StockTransferPrint;
